<template>
  <div
    class="bg-gray-50 rounded-2xl p-5 space-y-3"
    :class="{
      shimmerContainer:
        fees?.loadingFees ||
        $stores.services.state.transactionInitiation.convertingAmount
    }"
  >
    <!-- Bonus Section -->
    <div
      class="flex justify-between items-center py-2"
      v-if="fees.bonus > 0"
    >
      <span class="text-sm text-gray-600 shimmerTarget">Bonus offert</span>
      <span class="shimmerTarget font-semibold text-green-600">
        +{{ formatAmount(fees.bonus) }} CFA
      </span>
    </div>

    <!-- Transaction Details -->
    <div
      class="flex justify-between items-center py-2"
      v-if="transactionData.recipientAmount"
    >
      <span class="text-sm text-gray-600 shimmerTarget">Montant</span>
      <span
        class="shimmerTarget font-semibold text-gray-900"
        v-if="operation.id == 'withdraw' || operation.id == 'sell'"
      >{{ formatAmount(transactionData.senderAmount) }} CFA</span
      >
      <span class="shimmerTarget font-semibold text-gray-900" v-else
      >{{ formatAmount(transactionData.recipientAmount) }} CFA</span
      >
    </div>

    <div
      class="flex justify-between items-center py-2"
      v-if="fees.fee > 0"
    >
      <span class="text-sm text-gray-600 shimmerTarget">Frais</span>
      <span class="shimmerTarget font-semibold text-gray-900"
      >{{ formatAmount(fees.fee) }} CFA</span
      >
    </div>

    <div
      class="flex justify-between items-center py-2"
      v-if="transactionData.phoneNumber"
    >
      <span class="text-sm text-gray-600 shimmerTarget">Téléphone</span>
      <span class="shimmerTarget font-medium text-gray-900">{{
        transactionData.phoneNumber
      }}</span>
    </div>

    <div
      class="flex justify-between items-center py-2"
      v-if="transactionData.bookmakerIdToUse"
    >
      <span class="text-sm text-gray-600 shimmerTarget">ID bookmaker</span>
      <span class="shimmerTarget font-medium text-gray-900">
        <BookmakerAccountDetail
          :bookmaker="service.id"
          :bookmakerId="transactionData.bookmakerIdToUse"
        />
      </span>
    </div>

    <!-- Total Section - simplified -->
    <div class="border-t border-gray-200 pt-3 mt-2" v-if="operation.id == 'withdraw'">
      <div class="flex justify-between items-center py-2">
        <span class="text-sm text-gray-600 shimmerTarget">Total à recevoir</span>
        <span class="shimmerTarget font-semibold text-gray-900">
          {{ formatAmount(transactionData.recipientAmount) }} CFA
        </span>
      </div>
    </div>

    <div class="border-t border-gray-200 pt-3 mt-2" v-else-if="operation.id == 'buy'">
      <div class="flex justify-between items-center py-2">
        <span class="text-sm text-gray-600 shimmerTarget">Total à payer</span>
        <span class="shimmerTarget font-semibold text-gray-900">
          {{ formatAmount(transactionData.senderAmount) }} CFA
        </span>
      </div>
      <div class="flex justify-between items-center py-2">
        <span class="text-sm text-gray-400 shimmerTarget pl-3"></span>
        <span class="shimmerTarget text-sm text-gray-500">
          ({{ formatAmount(transactionData.recipientAmountOriginalCurrency) }} USDT)
        </span>
      </div>
    </div>

    <div class="border-t border-gray-200 pt-3 mt-2" v-else-if="operation.id == 'sell'">
      <div class="flex justify-between items-center py-2">
        <span class="text-sm text-gray-600 shimmerTarget">Total à recevoir</span>
        <span class="shimmerTarget font-semibold text-gray-900">
          {{ formatAmount(transactionData.recipientAmount) }} CFA
        </span>
      </div>
      <div class="flex justify-between items-center py-2">
        <span class="text-sm text-gray-400 shimmerTarget pl-3"></span>
        <span class="shimmerTarget text-sm text-gray-500">
          ({{ formatAmount(transactionData.senderAmountOriginalCurrency) }} USDT)
        </span>
      </div>
    </div>

    <div class="border-t border-gray-200 pt-3 mt-2" v-else>
      <div class="flex justify-between items-center py-2">
        <span class="text-sm text-gray-600 shimmerTarget">Total à payer</span>
        <span class="shimmerTarget font-semibold text-gray-900">
          {{ formatAmount(transactionData.senderAmount) }} CFA
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ServiceSummaryDialog',
  data() {
    return {};
  },
  computed: {
    service() {
      return this.$stores.services?.state?.transactionInitiation?.service;
    },
    operation() {
      return this.$stores.services?.state?.transactionInitiation?.operation;
    },
    fees() {
      return this.$stores.services?.state?.transactionInitiationFees || {};
    },
    transactionData() {
      return this.$stores.services?.state?.transactionInitiation || {};
    }
  },
  methods: {
    formatAmount(amount) {
      if (!amount) return '0';
      return new Intl.NumberFormat('fr-FR').format(amount);
    }
  }
});
</script>
